import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
	App: {
		backgroundColor: '#000',
		padding: '20px 40px',
		
	},
	toolbar: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-around',
		flexWrap: 'wrap'
		
	},
	projects: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'center',
	},
});
